import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import searchIcon from "../assets/images/search.svg";
import { setPage, setSearchString, setType } from "../features/filter/filterSlice";

const Header = () => {
  const dispatch = useDispatch();
  const { type } = useSelector((state) => state.filter);
  const [searchText, setSearchText] = useState("");

  const handleFilter = (e) => {
    dispatch(setPage(1));
    dispatch(setType(e.target.value));
  };

  const handleSearch = (e) => {
    e.preventDefault();
    dispatch(setType(""));
    dispatch(setPage(1));
    dispatch(setSearchString(searchText));
    setSearchText("");
  };
  return (
    <section className='filter-section'>
      <div className='radio_group'>
        <input type='radio' id='all' value='' name='type' checked={type === ""} onChange={(e) => handleFilter(e)} />
        <label htmlFor='all'>All</label>

        <input
          type='radio'
          id='income'
          value='income'
          name='type'
          checked={type === "income"}
          onChange={(e) => handleFilter(e)}
        />
        <label htmlFor='income'>Income</label>

        <input
          type='radio'
          id='expense'
          value='expense'
          name='type'
          checked={type === "expense"}
          onChange={(e) => handleFilter(e)}
        />
        <label htmlFor='expense'>Expense</label>
      </div>
      <form onSubmit={handleSearch}>
        <div className='search'>
          <input
            type='text'
            value={searchText}
            placeholder='search Transaction...'
            onChange={(e) => setSearchText(e.target.value)}
          />
          <button type='submit'>
            <img src={searchIcon} alt='search' />
          </button>
        </div>
      </form>
    </section>
  );
};

export default Header;
